module.exports = __webpack_public_path__ + "static/media/research-5.62edaf31.svg";